/**
 * Emails of users who should see the Products filter masked as
 * "Product 1", "Product 2", … instead of real drug names (see the
 * drug_name block in src/components/filters/index.tsx). Everyone else
 * sees real product names as normal.
 */
export const DEMO_USERS: string[] = ["Foresight_Demo@elusahealth.com"];
